/**
 * @generated SignedSource<<233286b414d283b68d0ed3e3eb0b1110>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookingType"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bookingType",
        "variableName": "bookingType"
      }
    ],
    "concreteType": "BookingType",
    "kind": "LinkedField",
    "name": "myBooking",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sourceCityName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "destinationCityName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pnrNo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pickupTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dropTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "qrCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dateOfJourney",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isPaymentSuccessful",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PassengerDetailsType",
        "kind": "LinkedField",
        "name": "passengerdetailSet",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "age",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gender",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MyBookingQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MyBookingQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e1a6710e0eafd94303d0f750730880c4",
    "id": null,
    "metadata": {},
    "name": "MyBookingQuery",
    "operationKind": "query",
    "text": "query MyBookingQuery(\n  $bookingType: MyBookingFilterEnum\n) {\n  myBooking(bookingType: $bookingType) {\n    id\n    sourceCityName\n    destinationCityName\n    pnrNo\n    pickupTime\n    dropTime\n    qrCode\n    dateOfJourney\n    isPaymentSuccessful\n    passengerdetailSet {\n      id\n      name\n      age\n      gender\n    }\n  }\n}\n"
  }
};
})();

node.hash = "6df507b420610db6f77e57e30f31dac6";

module.exports = node;
